// extracted by mini-css-extract-plugin
export default {"saveLink":"Tx1YNIVhi33kCoVDGFvY","modalBody":"DvgGhMc3__e40NlKPL1P"};